import { FC } from 'react';
import styles from './heroCardRange.module.scss';

type Props = {
  value?: number;
  id?: string;
  cursor?: 'default' | 'pointer';
};

export const HeroCardRange: FC<Props> = ({
  value = 70,
  id = 'amount-range',
  cursor = 'pointer',
}) => {
  return (
    <label htmlFor={id} id={id} aria-label="Loan amount">
      <input
        id={id}
        className={styles.range}
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={(event) => event.preventDefault()}
        style={{
          background: `linear-gradient(to right, white ${value}%, #ffffff33 ${value}%)`,
          cursor,
        }}
      />
    </label>
  );
};
